<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      @click="handleHide"
    >
      <custom-carousel 
        v-if="screensaverImages"
        :onClick="handleHide"
        :images="screensaverImages"
      />
    </v-dialog>
  </v-row>
</template>
<script>
import axios from 'axios'
import { parseString } from 'xml2js'
import api from '@/services/api'
import utils from '@/services/utils'
import CustomCarousel from './CustomCarousel'
export default {
  components: {
    CustomCarousel,
  },
  data: () => ({
    timer: null,
    dialog: false,
    notifications: false,
    sound: true,
    widgets: false,
    screensaverImages: null,
  }),
  computed: {
    urlDomain () {
      return utils.getDomain()
    },
    isScreensaver () {
      return this.$route.query.screensaver || this.urlDomain === 'prestigeownersclubtotem' ? true : false
    },
    screensaverTime () {
      return this.$route.query.screensaverTime ? this.$route.query.screensaverTime | 0 : 300000
    },
  },
  mounted () {
    if (!this.isScreensaver) return
    const that = this
    document.onclick = (event) => {
      // Compensate for IE<9's non-standard event model
      if (event === undefined) event= window.event
      var target= 'target' in event? event.target : event.srcElement
      that.updateDelay(target)
    }
    this.updateDelay()
  },
  methods: {
    updateDelay (target) {
      this.prepareDelay()
    },
    handleGetImages () {
      api.getItem('enterprises', false, `screensaver/${this.urlDomain}`)
        .then(response => {
          if (response.Screensaver && response.Screensaver.length > 0) {
            axios.get(response.Screensaver)
              .then (response => {
                try {
                  const that = this
                  parseString (response.data, (err, results) => {
                  // parsing to json
                    that.screensaverImages = null
                    that.screensaverImages = results.rss.channel.shift().item.map(item => {
                      return item['media:content'].shift()['$'].url
                    }).filter(x => x.indexOf('.mp4') === -1)
                    if (that.screensaverImages && that.screensaverImages.length > 0) {
                      this.dialog = true
                    } else {
                      this.prepareDelay()
                    }
                  })
                } catch (error) {
                  console.log(error)
                  this.prepareDelay()
                }
              })
          } else {
            this.screensaverImages = null
            this.prepareDelay()
          }
        })
    },
    prepareDelay () {
      const delayInMilliseconds = this.screensaverTime
      //const delayInMilliseconds = 5000
      if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.handleGetImages()
      }, delayInMilliseconds)
    },
    handleHide () {
      this.dialog = false
      this.prepareDelay()
    },
  },
}
</script>
